import React from 'react';

const FLOWS = [
    { n: '01', cls: 'blue', t: 'All applicants', d: 'Every application triggers a free structured readiness profile. Your team sees a readiness score before reading a deck.', get: 'Pre-screening done before your team opens a single deck.' },
    { n: '02', cls: 'pink', t: 'Rejected applicants', d: 'Every company you decline gets a warm handover — to VCs, advisors, and other programmes.', get: "A constructive exit that protects your network's reputation." },
    { n: '03', cls: 'green', t: 'Accepted pitchers', d: 'Every invited company completes a certified Diligence Pack during the pre-pitch waiting period.', getImg: require('../../../../images/landing-pages/angel-networks/certificates.png') },
    { n: '04', cls: 'blue', t: 'Diligence Tools', d: 'We give your angels access to the toolkit that we provide our VCs.', get: 'More informed angel investors before they invest.' },
];

const AngelFlowsSection = () => (
    <section id="how-it-works" className="lp-flows-sec">
        <h2 className="lp-flows-head" data-lp-reveal>Three flows. One platform. No cost to the network.</h2>
        <div className="lp-flows">
            <div className="lp-flows-line" aria-hidden="true" />
            {FLOWS.map((f, i) => (
                <div className="lp-flow" key={i} data-lp-reveal data-lp-delay={i * 120}>
                    <div className={`n ${f.cls}`}>{f.n}</div>
                    <h3>{f.t}</h3>
                    <p>{f.d}</p>
                    {f.getImg
                        ? <img className="lp-flow-cert" src={f.getImg} alt="Bronze / Silver / Gold certification" />
                        : <p className="get"><span>You get:</span> {f.get}</p>}
                </div>
            ))}
        </div>
        <p className="lp-flows-foot" data-lp-reveal>Operator setup: 30 minutes. Company onboarding: 20 minutes.<br /><span>Starts in days, not months.</span></p>
    </section>
);

export default AngelFlowsSection;
